import { render, staticRenderFns } from "./FamilyMemberComponent.vue?vue&type=template&id=2e7bfe15&scoped=true"
import script from "./FamilyMemberComponent.vue?vue&type=script&lang=ts"
export * from "./FamilyMemberComponent.vue?vue&type=script&lang=ts"
import style0 from "./FamilyMemberComponent.vue?vue&type=style&index=0&id=2e7bfe15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7bfe15",
  null
  
)

export default component.exports